import { useItemFunctionMenuItemsType } from '../../../../../Utils/ObjektVyUtils';
import { useFrontendUrl } from '../../../../../Hooks/useFrontendUrl';

export const useStatistikrapporteringFunktionsMenyItems: useItemFunctionMenuItemsType =
  input => {
    let collectionPart = input.associationName
      ? `${input.associationName}/`
      : '';
    let baseUrl = `${useFrontendUrl()}/Rutin/Kalender/`;
    const url = `${baseUrl}${collectionPart}${input.id}/`;

    return [
      {
        id: 'Öppna i ny flik',
        caption: 'Öppna i ny flik',
        onClick: () => {
          if (input.collection) {
            window.open(url, '_blank');
          }
        },
        iconType: 'open_in_new',
      },
    ];
  };
